/* Backstop for async Shopify variant changes in destinations without a general shipping rate. */
(() => {
  const blockedSelector = 'product-form-context[data-rv-shipping-blocked="true"]';
  const sync = () => {
    document.querySelectorAll(blockedSelector).forEach(root => {
      root.querySelectorAll('button[data-add-to-cart]').forEach(button => {
        button.disabled = true;
        button.setAttribute('aria-label', 'Delivery unavailable');
        const label = button.querySelector('[data-atc-text]');
        if (label && !button.classList.contains('product--icon') && label.textContent.trim() !== 'Delivery unavailable')
          label.textContent = 'Delivery unavailable';
      });
    });
    document.querySelectorAll('.rv-sticky-buy-shipping-restricted button[data-add-to-cart]')
      .forEach(button => { button.disabled = true; });
  };
  const later = () => { sync(); setTimeout(sync, 100); setTimeout(sync, 350); };
  document.addEventListener('submit', (e) => {
    if (e.target.closest(blockedSelector)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', (e) => {
    const button = e.target.closest('button[data-add-to-cart]');
    if (button && (button.closest(blockedSelector) || button.closest('.rv-sticky-buy-shipping-restricted'))) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
  ['change','variant:change','variant-change','product:variant-change','shopify:section:load']
    .forEach(name => document.addEventListener(name, later));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
})();